module.exports = __webpack_public_path__ + "static/media/logo-uphoc.b22ee25f.jpg";